import TableHead from "./Table/TableHead";
import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";
import { Table, TBody } from "../components";
import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import DeleteModal from "./Table/DeleteModal";

function Customers() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    pagination,
    setOrder,
    clearFilters,
    systemId,
    setSystemId,
    refetchDocs,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
    paymentStatuses,
    selectedPaymentStatuses,
    setSelectedPaymentStatuses,
    isFiltered,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          pagination,
          setOrder,
          clearFilters,
          systemId,
          setSystemId,
          refetchDocs,
          showDeleteModal,
          setShowDeleteModal,
          handleDelete,
          paymentStatuses,
          selectedPaymentStatuses,
          setSelectedPaymentStatuses,
          isFiltered,
        }}
      >
        <Table
          label="Customers"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          handleAdd={() => navigate("add")}
          handleRemoveFilters={clearFilters}
          pagination={pagination}
          url="customers/search"
          filters={{
            payment_status: {
              options: paymentStatuses,
              selected: selectedPaymentStatuses,
              setSelected: setSelectedPaymentStatuses,
            },
          }}
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => (
              <TableRow key={doc?.id || i} doc={doc} />
            ))}
          </TBody>
        </Table>
      </TableContext.Provider>

      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          systemId={systemId}
        />
      )}
    </>
  );
}

export default Customers;
